export default "__VITE_ASSET__X$jy9YfJ__"